import React, { useEffect, useRef, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { Menu } from '@mui/icons-material';
import { DrawerCustom } from '../../components/Drawer/DrawerCustom';
import { AddingSectorComponent } from '../../components/AddingSectorComponent';
import { Edit } from '../../constructor/work/Edit';
import { MenuLine } from '../../components/MunuLine/MenuLine';
import {
  EventChangeScaleObject,
  EventChangeScaleObjectType,
  EventSelectControlPoint,
  EventSelectControlPointDetailType,
  EventSelectDrainFunnel,
  EventSelectDrainFunnelDetailType,
  EventSelectLinkingDetailType,
  EventSelectLinkingLine,
} from '../../helpers/events';
import {
  ControlPointObjectType,
  DataFileType,
  DrainFunnelObjectType,
  LinkingPointObjectType,
  UrlParamsObjectType,
} from '../../constructor/types';
import { MenuCircle } from '../../components/MenuCircle/MenuCircle';
import { StepsEnum } from '../../helpers/types';
import { LoadImageTexture } from '../../components/LoadTexture/LoadImageTexture';
import { DrainFunnel } from '../../components/DrainFunnel/DrainFunnel';
import { MenuDrainFunnel } from '../../components/MenuDrainFunnel/MenuDrainFunnel';
import { SetScaleComponent } from './components/SetScaleComponent';
import { SettingsComponent } from '../../components/SettingsComponent';
import { WrapperCalculateSupports } from '../../components/CalcSupportsForTiles/WrapperCalculateSupports';
import { useGetProjectsLazyQuery } from '../../graphql/query/__generated__/getProjects';
import { useLocation } from 'react-router-dom';
import {setProjectName} from "../../graphql/store/functionsWitingCache";

type ObjectMenuType = {
  x: number;
  y: number;
  isOpen: boolean;
  object?: LinkingPointObjectType | ControlPointObjectType | DrainFunnelObjectType | null;
  uuid?: string;
};
export const Home = () => {
  const location = useLocation().state as UrlParamsObjectType;
  const [runGetProject, { data: dataCode }] = useGetProjectsLazyQuery();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataModelMenu, setDataModelMenu] = useState<ObjectMenuType>({
    x: 0,
    y: 0,
    isOpen: false,
    object: null,
  });
  const [dataModelMenuCircle, setDataModelMenuCircle] = useState<ObjectMenuType>({
    x: 0,
    y: 0,
    isOpen: false,
    object: null,
  });
  const [dataModelDrainFunnel, setDataModelDrainFunnel] = useState<ObjectMenuType>({
    x: 0,
    y: 0,
    isOpen: false,
    object: null,
    uuid: '',
  });
  const [selectStep, setSelectStep] = useState(StepsEnum.Step_1);
  const [, setModalScale] = useState({ isOpen: false, originSize: 200 });
  const [scaleComponent, setScaleComponent] = useState(false);
  const canvasRef = useRef();
  const firstDownload = useRef(true);

  const handlerListenerSelectLine = (evt: CustomEvent<EventSelectLinkingDetailType>) => {
    const { position, selectObject } = evt.detail;
    setDataModelMenu({ isOpen: true, x: position.x, y: position.y, object: selectObject });
  };
  const handlerListenerSelectControlPoint = (
    evt: CustomEvent<EventSelectControlPointDetailType>
  ) => {
    const { position, selectObject } = evt.detail;
    setDataModelMenuCircle({ isOpen: true, x: position.x, y: position.y, object: selectObject });
  };

  const handlerListenerSelectDrainFunnel = (evt: CustomEvent<EventSelectDrainFunnelDetailType>) => {
    const { uuidPointMove, position, selectObject } = evt.detail;
    setDataModelDrainFunnel({
      isOpen: true,
      object: selectObject,
      x: position.x,
      y: position.y,
      uuid: uuidPointMove,
    });
  };
  const handlerListenerChangeScaleObject = (evt: CustomEvent<EventChangeScaleObjectType>) => {
    setScaleComponent(evt.detail.isObjectScale);
  };
  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };
  const checkRecordSector = () => {
    // console.log('check record sector', Edit.Load?.scene.children);
    if (dataCode?.projects?.length) {
      const sector = dataCode.projects[0].sector;
      // console.log(`${HOST_API}${dataCode.projects[0].background?.filename}`);
      if (sector) {
        let substrateImage: DataFileType | undefined;
        if (dataCode.projects[0].background?.filename) {
          // setSubstrate(`${HOST_API}${dataCode.projects[0].background?.filename}`);
          substrateImage = {
            width: dataCode.projects[0].background?.width ?? 0,
            height: dataCode.projects[0].background?.height ?? 0,
            base64data: dataCode.projects[0].background?.base64,
          };
          if (dataCode.projects[0].background_info) {
            substrateImage.paramsPruning = JSON.parse(dataCode.projects[0].background_info);
          }
        }
        Edit.restoreSector(sector, substrateImage);
      }
    }
  };

  useEffect(() => {
    if (dataCode && firstDownload.current) {
      firstDownload.current = false;
      checkRecordSector();
    }
  }, [dataCode]);
  useEffect(() => {
    if (location && location.code) {

      runGetProject({ variables: { code: location.code } }).then();
    }
  }, [location]);
  useEffect(() => {
    if (dataCode && dataCode.projects?.length) {
      const project = dataCode.projects[0]
      setProjectName({
        dataWrite: {
          nameProject: project.name,
        },
      });

    }
  }, [dataCode]);

  useEffect(() => {
    if (canvasRef.current) {
      Edit.addLoad(canvasRef.current);
    }
    document.addEventListener(EventSelectLinkingLine, handlerListenerSelectLine);
    document.addEventListener(EventSelectControlPoint, handlerListenerSelectControlPoint);
    document.addEventListener(EventSelectDrainFunnel, handlerListenerSelectDrainFunnel);
    document.addEventListener(EventChangeScaleObject, handlerListenerChangeScaleObject);
    return () => {
      Edit.removeLoad();
      document.removeEventListener(EventSelectLinkingLine, handlerListenerSelectLine);
      document.removeEventListener(EventSelectControlPoint, handlerListenerSelectControlPoint);
      document.removeEventListener(EventSelectDrainFunnel, handlerListenerSelectDrainFunnel);
      document.removeEventListener(EventChangeScaleObject, handlerListenerChangeScaleObject);
    };
  }, []);

  return (
    <Box width="100%" height="100%" position="relative">
      <Box position="absolute" top={0} left={0} width="100%" height="100%" ref={canvasRef} />
      <Box position="absolute" top="20px" right="20px">
        <IconButton onClick={handleDrawerOpen} edge="start">
          <Menu style={{ fontSize: '30px' }} />
        </IconButton>
      </Box>
      <DrawerCustom
        isOpen={openDrawer}
        selectedStep={selectStep}
        closeDrawer={() => setOpenDrawer(false)}
        handlerSelectStep={i => setSelectStep(i)}
      >
        {selectStep === StepsEnum.Step_1 && <LoadImageTexture />}
        {selectStep === StepsEnum.Step_2 && (
          <AddingSectorComponent
            sector={
              dataCode?.projects && dataCode.projects.length > 0
                ? dataCode.projects[0].sector ?? ''
                : ''
            }
          />
        )}
        {selectStep === StepsEnum.Step_3 && <DrainFunnel />}
        {selectStep === StepsEnum.Step_4 && <WrapperCalculateSupports />}
        {selectStep === StepsEnum.Step_5 && <SettingsComponent />}
      </DrawerCustom>
      {dataModelMenu.isOpen && (
        <MenuLine
          selectedObjectLine={dataModelMenu?.object as LinkingPointObjectType}
          positionY={dataModelMenu.y}
          positionX={dataModelMenu.x}
          closeMenu={() => setDataModelMenu({ isOpen: false, x: 0, y: 0, object: null })}
          openModalScale={size => setModalScale({ isOpen: true, originSize: size })}
        />
      )}
      {dataModelMenuCircle.isOpen && (
        <MenuCircle
          selectedObjectPoint={dataModelMenuCircle?.object as ControlPointObjectType}
          positionX={dataModelMenuCircle.x}
          positionY={dataModelMenuCircle.y}
          closeMenu={() => setDataModelMenuCircle({ isOpen: false, x: 0, y: 0, object: null })}
        />
      )}
      {dataModelDrainFunnel.isOpen && (
        <MenuDrainFunnel
          parentDrainFunnel={dataModelDrainFunnel.object as DrainFunnelObjectType}
          uuidChild={dataModelDrainFunnel?.uuid || ''}
          positionX={dataModelDrainFunnel.x}
          positionY={dataModelDrainFunnel.y}
          closeMenu={() =>
            setDataModelDrainFunnel({ isOpen: false, uuid: '', object: null, x: 0, y: 0 })
          }
        />
      )}
      {/* {modalScale.isOpen && (
        <ChangeScaleModal
          originSize={modalScale.originSize}
          closeModal={() => setModalScale({ isOpen: false, originSize: 0 })}
        />
      )}*/}

      <SetScaleComponent isOpen={scaleComponent} />
    </Box>
  );
};
